
import {
    GET_COMPANIES_SUCCESS,
    GET_COMPANIES_FAIL,
    UPDATE_COMPANY_SUCCESS,
    UPDATE_COMPANY_FAIL,
    DELETE_COMPANY_SUCCESS,
    DELETE_COMPANY_FAIL,
    TOGGLE_COMPANY_STATUS_SUCCESS,
    TOGGLE_COMPANY_STATUS_FAIL,
    ADD_NEW_COMPANY_SUCCESS,
    ADD_NEW_COMPANY_FAIL,
    GET_COMPANY_DETAIL_SUCCESS,
    GET_COMPANY_DETAIL_FAIL,
    ASSIGN_PLAN_SUCCESS,
    ASSIGN_PLAN_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    companies: [],
    companyDetail: null,
    error: {},
}

const companies = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_COMPANIES_SUCCESS:
            return {
                ...state,
                // Laravel pagination returns an object with a 'data' array
                companies: action.payload.data ? action.payload.data : action.payload,
            }

        case GET_COMPANIES_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_COMPANY_SUCCESS:
            const updatedCompany = action.payload.company ? action.payload.company : action.payload;
            return {
                ...state,
                companies: state.companies.map(company =>
                    company.id.toString() === updatedCompany.id.toString()
                        ? { ...company, ...updatedCompany }
                        : company
                ),
            }

        case UPDATE_COMPANY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_COMPANY_SUCCESS:
            return {
                ...state,
                companies: state.companies.filter(
                    company => company.id.toString() !== action.payload.toString()
                ),
            }

        case DELETE_COMPANY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case TOGGLE_COMPANY_STATUS_SUCCESS:
            const toggledCompany = action.payload.company ? action.payload.company : action.payload;
            return {
                ...state,
                companies: state.companies.map(company =>
                    company.id.toString() === toggledCompany.id.toString()
                        ? { ...company, status: toggledCompany.status }
                        : company
                )
            }

        case TOGGLE_COMPANY_STATUS_FAIL:
            return {
                ...state,
                error: action.payload
            }

        case ADD_NEW_COMPANY_SUCCESS:
            return {
                ...state,
                companies: [action.payload, ...state.companies],
            }

        case ADD_NEW_COMPANY_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_COMPANY_DETAIL_SUCCESS:
            return {
                ...state,
                companyDetail: action.payload,
            }

        case GET_COMPANY_DETAIL_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ASSIGN_PLAN_SUCCESS:
            return {
                ...state,
                companyDetail: {
                    ...state.companyDetail,
                    subscription: action.payload.subscription
                }
            }

        default:
            return state
    }
}

export default companies
